import { render, staticRenderFns } from "./Consumebs.vue?vue&type=template&id=61aaf3b7"
import script from "./Consumebs.vue?vue&type=script&lang=js"
export * from "./Consumebs.vue?vue&type=script&lang=js"
import style0 from "./Consumebs.vue?vue&type=style&index=0&id=61aaf3b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports